module.exports = __webpack_public_path__ + "fonts/Flaticon.3e4331e.ttf";